'use client';

import { useEffect } from 'react';
import { useSiteConfig } from 'modules/shop/siteConfig/hooks';
import { ClientPageType } from 'src/app/types';

export const PageType = ({ type }: { type: ClientPageType | null }) => {
  const { setGtmData } = useSiteConfig();

  useEffect(() => {
    type &&
      setGtmData &&
      setGtmData((data) => ({ ...data, pageType: type as ClientPageType }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};
